import { render, staticRenderFns } from "./SMSTelnyx.vue?vue&type=template&id=38b23d7c&"
import script from "./SMSTelnyx.vue?vue&type=script&lang=js&"
export * from "./SMSTelnyx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports